export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-Ver-1-06-3.8d6417c7.jpg";